import sharedService from "../../services/sharedService";
import { initialState } from "./initialState";
import { errorMessage } from "../../constants/responseMessages";
import {
  API_FILE_URL_STATUS,
  API_STATUS,
  // CLEAR_API_STATUS,
  GET_FILE_URL,
  GET_FOLDERS_AND_FILES,
  GET_PENDING_BATCHES_LIST,
} from "./types";

const service = new sharedService();

export const clearApiStatus = () => {
  return (dispatch) => {
    dispatch({
      type: API_STATUS,
      payload: {},
    });
  };
};

export const clearApiFileUrlStatus = () => {
  return (dispatch) => {
    dispatch({
      type: API_FILE_URL_STATUS,
      payload: {},
    });
  };
};

export const getFoldersAndFiles = (type, id) => {
  return (dispatch) => {
    dispatch({
      type: GET_FOLDERS_AND_FILES,
      payload: {},
    });
    dispatch({ type: API_STATUS, payload: { message: "", loader: true } });

    service
      .getFoldersAndFiles(id)
      .then((res) => {
        dispatch({
          type: API_STATUS,
          payload: { message: "", loader: false, apiSuccess: true },
        });
        dispatch({
          type: GET_FOLDERS_AND_FILES,
          payload: {
            data: res?.data?.data,
            type: type,
            isEmptyData: res?.data?.data.length === 0 ? true : false,
          },
        });
      })
      .catch((error) => {
        dispatch({
          type: API_STATUS,
          payload: {
            ...initialState?.apiStatus,
            apiError: true,
            message: errorMessage(error),
            loader: false,
          },
        });
        dispatch({
          type: GET_FOLDERS_AND_FILES,
          payload: {},
        });
      });
  };
};

export const getFileUrl = (id) => {
  return (dispatch) => {
    dispatch({
      type: API_FILE_URL_STATUS,
      payload: { message: "", loader: true },
    });
    dispatch({
      type: GET_FILE_URL,
      payload: [],
    });
    service
      .getFileUrl(id)
      .then((res) => {
        dispatch({
          type: GET_FILE_URL,
          payload: res?.data?.data,
        });
        dispatch({
          type: API_FILE_URL_STATUS,
          payload: { message: "", loader: false, apiSuccess: true },
        });
      })
      .catch((error) => {
        dispatch({
          type: GET_FILE_URL,
          payload: [],
        });
        dispatch({
          type: API_FILE_URL_STATUS,
          payload: {
            ...initialState?.apiStatus,
            apiError: true,
            message: errorMessage(error),
            loader: false,
          },
        });
      });
  };
};

export const getPendingBatchesList = () => {
  return (dispatch) => {
    dispatch({
      type: GET_PENDING_BATCHES_LIST,
      payload: { data: [], loader: true, message: "" },
    });
    service
      .getPendingBatchesList()
      .then((json) => {
        dispatch({
          type: GET_PENDING_BATCHES_LIST,
          payload: { data: json.data.data, loader: false, message: "" },
        });
      })
      .catch((error) => {
        dispatch({
          type: GET_PENDING_BATCHES_LIST,
          payload: { data: [], message: errorMessage(error), loader: false },
        });
      });
  };
};
